<template>
  <div class="home-view">
    <!-- HeroImageコンポーネントを使用し、画像パスをプロパティで渡す -->
    <!-- <HeroImage :logoUrl="logo"
      :mobileImageUrl="fullMobileImagePath"
      :desktopImageUrl="fullDesktopImagePath"
    /> -->
    <HeroImage2  
      :logoUrl="logo"
      media-type="video"
      :mobile-video-url="`${basePath}Images/kv/kv_2025_natadera_sample_sp.mp4`"
      :desktop-video-url="`${basePath}Images/kv/kv_2025_natadera_sample_pc.mp4`"
    />
    <AnnouncementBar 
      :showAnnouncement="isEventEnded"
    />
    <div class="arrange">
      <div class="bg-arrange" :style="backgroundStyle"></div>
      <MainHeading />
      <InforMation />
    </div>
    <!-- <YouTubeEmbed videoId="txVGjfNyrJg" />-->
    <ContentsBlock />
    <AreaMap />
    <CollaboRation />
    <!--<FoodMenu />  -->
    <TicketsTable />
    <SetTickets />
    <!-- <TicketsTable2 /> -->
    <OutlineAccess />
    <FaQuestions />
    <!-- <OtherEvents /> -->
    <!-- <BannerBlock />-->
    <CreditList />

    <!-- モバイル表示時にスクロール中のみ画面下に固定された購入ボタン -->
    <div v-if="isMobileDevice && showPurchaseButton" :class="{ 'show-button': showButton }" class="mobile-purchase-container">
      <v-btn 
        :href="purchaseUrl"
        target="_blank"
        size="x-large"
        rounded="xl" 
        variant="outlined"
        elevation="16"
        color="white"
        class="buy-button-mobile bg-secondary align-center">
        <SvgIcon type="mdi" :path="mdiTicketConfirmationOutline" size="24" />
        <span class="ml-2" v-html="$t('purchase')"></span>
      </v-btn>
      <p class="external-site-notice-mobile" v-html="$t('external_site_notice')"></p>
    </div>

    <!-- PC用購入ボタン -->
    <div v-if="!isMobileDevice && showPurchaseButton" :class="{ 'show-button': showButton }" class="pc-purchase-container">
      <v-btn
        :href="purchaseUrl"
        target="_blank"
        variant="outlined"
        class="buy-button-pc bg-primary"
      >
        <v-img :src="ticket_icon" width="48px"></v-img>
        <span v-html="$t('purchase')" class="mt-2"></span>
      </v-btn>
      <p class="external-site-notice-pc" v-html="$t('external_site_notice')"></p>
    </div>

    <!-- トップに戻るボタン -->
    <v-btn 
      :class="{ 'show-button': showBackToTopButton }"
      icon
      href="#top"
      v-smooth-scroll
      class="back-to-top-button"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import HeroImage2 from '@/components/HeroImage2.vue';
import AnnouncementBar from '@/components/AnnouncementBar.vue';
import MainHeading from '@/components/MainHeading.vue';
import InforMation from '@/components/InforMation.vue';
import YouTubeEmbed from '@/components/YouTubeEmbed.vue';
import ContentsBlock from '@/components/ContentsBlock.vue';
import AreaMap from '@/components/AreaMap.vue';
import CollaboRation from '@/components/CollaboRation.vue';
import BannerBlock from '@/components/BannerBlock.vue';
import TicketsTable from '@/components/TicketsTable.vue';
import SetTickets from '@/components/SetTickets.vue';
import OutlineAccess from '@/components/OutlineAccess.vue';
import FaQuestions from '@/components/FaQuestions.vue';
import OtherEvents from '@/components/OtherEvents.vue';
import CreditList from '@/components/CreditList.vue';
import heroImagePaths from '@/locales/HeroImage';
import ticketsData from '@/locales/Tickets';
import { mdiTicketConfirmationOutline } from "@mdi/js";
import VueSmoothScroll from 'vue3-smooth-scroll';
import { useI18n } from 'vue-i18n';
import { getBasePath } from '@/utils/basePath';
import { isEventEnded } from '@/config/eventStatus';

const { t, locale } = useI18n();

// basePathユーティリティからベースパスを取得
const basePath = computed(() => getBasePath());

/* チケットボタンアイコン */
const ticket_icon = `${basePath.value}/Images/common/ticket-white.svg`;

// 背景あしらい
const backgroundStyle = computed(() => ({
  backgroundImage: `url('${basePath.value}/Images/bg/25_10_natadera_lp_1920_700.jpg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center bottom',
  backgroundRepeat: 'no-repeat',
}));

const logo = computed(() => {
  return `${basePath.value}Images/kv/yorusanpo_logo_sp.png`;
});

// 購入ボタンのURLをTickets.jsのデータから取得
const purchaseUrl = computed(() => {
  try {
    // 直接インポートしたデータから取得
    const currentLocale = locale.value;
    const agencyItems = ticketsData[currentLocale]?.tickets?.agency?.items;
    
    if (Array.isArray(agencyItems)) {
      // 日本語の場合はアソビュー、英語の場合はKKdayのリンクを使用
      return currentLocale === 'ja' 
        ? agencyItems.find(item => item.text === 'アソビュー！')?.link || ''
        : agencyItems.find(item => item.text === 'KKday')?.link || '';
    }
  } catch (error) {
    console.error('Error getting purchase URL:', error);
  }
  
  // フォールバックURL
  return locale.value === 'ja' 
    ? 'https://www.asoview.com/channel/tickets/5Q3BtRiSf3/'
    : 'https://www.kkday.com/en-us/product/195567';
});

// KKdayのURLを言語に応じて分岐（既存のコードを保持）
const kkdayUrl = computed(() => {
  return locale.value === 'ja' 
    ? 'https://www.kkday.com/ja/product/195567?cid=13044&ud1=officialwebsite'
    : 'https://www.kkday.com/en/product/195567?cid=13044&ud1=officialwebsite';
});

// ヒーローイメージ
const fullMobileImagePath = computed(() => {
  return `${basePath.value}${heroImagePaths[locale.value].mobile}`;
});

const fullDesktopImagePath = computed(() => {
  return `${basePath.value}${heroImagePaths[locale.value].desktop}`;
});

// お知らせ表示の状態を管理する変数
//const showAnnouncement = ref(true); 

// 購入ボタン表示の状態を管理する変数
const showPurchaseButton = ref(!isEventEnded); // イベント終了時は購入ボタンを非表示

// 動画IDと表示状態を管理するためのリアクティブデータ
const showVideo = ref(true); // 動画を表示するかどうかの状態

const isMobileDevice = ref(false);
const showButton = ref(false);
const showBackToTopButton = ref(false);

// スクロール位置に応じたボタンの表示制御
const checkDevice = () => {
  isMobileDevice.value = window.innerWidth <= 600;
};


// スクロール位置に応じたボタンの表示制御
const handleScroll = () => {
  const scrollY = window.scrollY;
  const viewportHeight = window.innerHeight;
  const fullHeight = document.documentElement.scrollHeight;
  const footerHeight = document.querySelector('footer')?.offsetHeight || 0;

  // 最下部に到達する直前に外に出ないように調整
  const threshold = 0; // この閾値を調整

 // ボタンが表示されるタイミングを1/3に変更
  showButton.value = scrollY > 600 && scrollY + viewportHeight < fullHeight - footerHeight - threshold;
  showBackToTopButton.value = scrollY > fullHeight / 3 && scrollY + viewportHeight < fullHeight - footerHeight - threshold;

  // 最下部に到達した時もボタンを表示し続けるように修正
  if (scrollY + viewportHeight >= fullHeight - footerHeight) {
    showBackToTopButton.value = true;
  }
};

// スクロールイベントの監視
onMounted(() => {
  checkDevice();
  window.addEventListener('resize', checkDevice);
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkDevice);
  window.removeEventListener('scroll', handleScroll);
});
</script>


<style lang="scss" scoped>
.arrange {
  position: relative;
  overflow-y: hidden;
  z-index: 1;
}
// 背景あしらい
.bg-arrange {
  position: absolute;
  width: 100%;
  aspect-ratio: 1920/700;
  max-height: 100%;
  bottom: 0;
  z-index: -1;
  opacity: .3;
}
.mobile-purchase-container {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 100px);
  opacity: 0;
  z-index: 1000;
  transition: 0.2s all linear;
  text-align: center;
}

.mobile-purchase-container.show-button {
  transform: translate(-50%, 0);
  opacity: 1;
}

.buy-button-mobile {
  font-size: 14px;
  border-width: 2px;
  text-align: center;
}

.external-site-notice-mobile {
  color: white;
  font-size: 10px;
  margin: 4px 0 0 0;
  text-align: center;
  opacity: 0.8;
}

.pc-purchase-container {
  position: fixed;
  bottom: 80px;
  right: -150px;
  opacity: 0;
  z-index: 1000;
  transition: 0.2s all linear;
  text-align: center;
}

.pc-purchase-container.show-button {
  right: 30px;
  opacity: 1;
}

:deep(.buy-button-pc) {
  height: 150px !important;
  width: 150px !important;
  border-radius: 150px;
  border-width: 3px;
  font-size: 16px;
  text-align: center;
  .v-btn__content {
    white-space: wrap!important;;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

.external-site-notice-pc {
  color: white;
  font-size: 10px;
  margin: 8px 0 0 0;
  text-align: center;
  opacity: 0.8;
  width: 150px;
}

.back-to-top-button {
  position: fixed;
  right: -30px;
  bottom: 30px;
  transform: translate(0, 0);
  opacity: 0;
  z-index: 1000;
  transition: 0.3s all linear;
}

.back-to-top-button.show-button {
  transform: translate(-60px, 0);
  opacity: 1;
}

</style>